/**
 * VistoeraTASK-00133 — Video Asset Picker optimistic-delete helpers.
 *
 * Mirrors `ImageAssetPicker/imagePickerOptimisticDelete.ts`'s
 * `decrementPickerSummary`: after one video is optimistically removed
 * from the current page, adjust the cached sidebar facet counts
 * in-place (no network round trip) so the numbers never visibly regress
 * to a stale/higher value while the confirming `reconcileAfterDelete`
 * silent refetch is in flight.
 */
import type { VideoAssetItem, VideoAssetStats } from '../../api'

export function decrementVideoPickerStats(
  stats: VideoAssetStats | null,
  item: Pick<VideoAssetItem, 'source_kind' | 'is_published'>,
): VideoAssetStats | null {
  if (!stats) return null
  const next: VideoAssetStats = { ...stats }
  next.total = Math.max(0, next.total - 1)
  if (item.source_kind === 'ai_generated') {
    next.ai_generated = Math.max(0, next.ai_generated - 1)
    next.original = Math.max(0, next.original - 1)
  } else if (item.source_kind === 'continuous_generated') {
    next.continuous_generated = Math.max(0, next.continuous_generated - 1)
    next.original = Math.max(0, next.original - 1)
  } else if (item.source_kind === 'upload') {
    next.upload = Math.max(0, next.upload - 1)
  }
  if (item.is_published) {
    next.published = Math.max(0, next.published - 1)
  }
  return next
}
